/*
Copyright (c) 2024, HP Development Company, L.P. All rights reserved.
This software contains confidential and proprietary information of HP.
The user of this software agrees not to disclose, disseminate or copy
such Confidential Information and shall use the software only in accordance
with the terms of the license agreement the user entered into with HP.
*/

import React, { memo } from 'react';
import backgroundImage from '../../assets/images/backgroundDevicePage.png';
import './styles.scss';
import { DeviceListPageTemplateProps } from './types';
import Skeleton from '../skeleton';
import { borderRadius } from '../../base';
import { generateID } from '../../base/helper';

/**
 * UI Toolkit component Device List Page
 * @public
 */

const DeviceListPageTemplate = ({
  children,
  loading = false,
  id = generateID('clientos-ui-toolkit-device-list-page')
}: DeviceListPageTemplateProps) => {
  return (
    <div
      className="clientos-ui-toolkit-device-list"
      id={id}
    >
      <div
        className="clientos-ui-toolkit-device-list__image-container"
        id={`${id}__image-container`}
        aria-hidden="true"
      >
        <img
          id={`${id}__image`}
          src={backgroundImage}
          className="clientos-ui-toolkit-device-list__image-container__image"
        />
      </div>
      <div
        className="clientos-ui-toolkit-device-list__container"
        id={`${id}__container`}
      >
        <div
          id={`${id}__container__body`}
          className={`clientos-ui-toolkit-device-list__container__body ${loading ? 'clientos-ui-toolkit-device-list__container__body--loading' : ''}`}
        >
          {loading ? (
            <Skeleton
              id={`${id}__skeleton`}
              width="100%"
              height={300}
              radius={borderRadius.cornerRadius6}
            />
          ) : (
            children
          )}
        </div>
      </div>
    </div>
  );
};
export type { DeviceListPageTemplateProps };
export default memo(DeviceListPageTemplate);
